import React, { useState } from 'react';
import { Tabs } from 'new/elements/Tabs';
import * as PATHS from 'js/constants/pathnames';
import PageLayout from 'new/elements/pageLayout/PageLayout';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ServiceKeys } from 'new/components/settings/Authentication/ServiceKeys';
import { CreateServiceKeyModal } from 'new/components/settings/Authentication/ServiceKeys/CreateServiceKeyModal';

import styles from 'new/components/settings/Teams/Teams.module.scss';

interface Tab {
  value: string;
  label: string;
  Component: React.FunctionComponent;
}

const tabs: Tab[] = [
  {
    value: 'service_keys',
    label: 'Service Keys',
    Component: ServiceKeys as React.FunctionComponent,
  },
];

const initialTab = tabs[0].value;

export const Authentication: ScreenComponent<{}> = () => {
  const [selectedTab, setSelectedTab] = useState(initialTab);
  const tab = tabs.find((tab) => tab.value === selectedTab);
  const Component = tab ? tab.Component : React.Fragment;

  const onTabChange = ({}, value: string) => setSelectedTab(value);

  return (
    <PageLayout title="Authentication">
      <div className={styles.tabs}>
        <Tabs value={selectedTab} tabs={tabs} onChange={onTabChange} />
      </div>
      <Component />
    </PageLayout>
  );
};

Authentication.screenConfig = {
  path: `${PATHS.ROUTE_REDESIGN}/settings/authentication`,
  modals: [CreateServiceKeyModal],
  screenName: 'Authentication',
  pageTitle: 'Authentication',
  header: {
    title: 'Settings',
    slugTitle: 'Authentication',
  },
  domain: 'settings',
};
